import { List, TextField, EditButton, ShowButton, SimpleList, Datagrid, CreateButton, TopToolbar } from "react-admin";
import { EmptyList } from "server/components";
import { useMediaQuery } from "@mui/material";
import { getPermissions } from "auth/security/securityUtils";
import { checkPermission } from "server/security/utils";
import permissions from "app/permissions";
import { settings } from "app";
import { MOBILE_BREAKPOINT, SCIENTIFIC_DEGREES } from "utils/constants";
import { AdministrationExporter } from "../XlsxExporter";
import { ExportXlsButton } from "features/ExportXlsxButton";
import { MobileListRow } from "features/MobileListRow";

const ListScientificDegrees = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  const userPermissions = getPermissions();
  
  const ListActions = (hasCreate) => {
    return (
      <TopToolbar>
        { hasCreate && <CreateButton/> } 
        <ExportXlsButton exporter={AdministrationExporter(SCIENTIFIC_DEGREES)}/>
      </TopToolbar>
    )
  }

  return (
    <List
      title="Научни степени"
      sx={settings.style.expandStyle}
      actions={<ListActions hasCreate={checkPermission(userPermissions, permissions.canCreateEmployeeTitles)} />}
    >
      {isMobile ? (
        <SimpleList
          empty={<EmptyList />}
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => (
            <MobileListRow fields={[{ label: "Име на български език", value: record.nameBgShort }]} />
          )}
          secondaryText={record => (
            <div>
              <MobileListRow fields={[{ label: "Пълно име на български език", value: record.nameBg }]} />
              <MobileListRow fields={[{ label: "Име на английски език", value: record.nameEnShort }]} />
              <MobileListRow fields={[{ label: "Пълно име на английски език", value: record.nameEn }]} />
            </div>
          )}
          tertiaryText={() => (
            <>
              {checkPermission(userPermissions, permissions.canUpdateEmployeeTitles) && <EditButton label="" />}
              <ShowButton label="" />
            </>
          )}
        />
      ) : (
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
          sx={settings.style.firstExpandIconDatagrid}
        >
          <TextField
            source="nameBgShort"
            label="Име на български език"
            sortable={false}
          />
          <TextField
            source="nameBg"
            label="Пълно име на български език"
            sortable={false}
          />
          <TextField
            source="nameEnShort"
            label="Име на английски език"
            sortable={false}
          />
          <TextField
            source="nameEn"
            label="Пълно име на английски език"
            sortable={false}
          />
          {checkPermission(userPermissions, permissions.canUpdateEmployeeTitles) && <EditButton />}
          <ShowButton />
        </Datagrid>
      )}
    </List>
  );
};
export default ListScientificDegrees;
